import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'

const Login = ()=> import('@/components/Login');
const CheckLogin = ()=> import('@/components/CheckLogin');
const Error = ()=> import('@/components/Error')

const Download = ()=> import('@/components/download/Download')
const Map = ()=> import('@/components/map/map')

const GroupList = ()=> import('@/components/admin/groupList/GroupList')
const GroupEdit = ()=> import('@/components/admin/groupEdit/GroupEdit')
const GroupSection = ()=> import('@/components/admin/groupEdit/section/GroupSection')
const GroupPermissionSection = ()=> import('@/components/admin/groupEdit/section/PermissionSection')
const GroupLayoutSection = ()=> import('@/components/admin/groupEdit/section/LayoutSection')
const GroupLayoutListSubSection = ()=> import('@/components/admin/groupEdit/section/LayoutListSection')
const GroupLayoutEditSubSection = ()=> import('@/components/admin/groupEdit/section/LayoutEditSection')


const ClientList = ()=> import('@/components/admin/clientList/ClientList')
const ClientEdit = ()=> import('@/components/admin/clientEdit/ClientEdit')
const ClientSection = ()=> import('@/components/admin/clientEdit/section/ClientSection')
const ClientPermissionSection = ()=> import('@/components/admin/clientEdit/section/PermissionSection')
const ClientUserSection = ()=> import('@/components/admin/clientEdit/section/UserSection')

const Stats = ()=> import('@/components/admin/stats/Stats')
const StatsUserSection = ()=> import('@/components/admin/stats/section/UserSection')
const StatsMBFDSection = ()=> import('@/components/admin/stats/section/MBFDSection')

const UserList = ()=> import('@/components/admin/userList/UserList')
const UserEdit = ()=> import('@/components/admin/userEdit/UserEdit')
const UserSection = ()=> import('@/components/admin/userEdit/section/UserSection')
const UserAddressSection = ()=> import('@/components/admin/userEdit/section/AddressSection')
const UserLayoutSection = ()=> import('@/components/admin/userEdit/section/LayoutSection')
const UserLayoutListSubSection = ()=> import('@/components/admin/userEdit/section/LayoutListSection')
const UserLayoutEditSubSection = ()=> import('@/components/admin/userEdit/section/LayoutEditSection')

const MessageList = ()=> import('@/components/messages/MessageList')
const MessageWrite = ()=> import('@/components/messages/NewMessage')
const Message = ()=> import('@/components/messages/Message')

const GlobalFiles = ()=> import('@/components/globalFiles/GlobalFiles')

const UploadAsb = ()=> import('@/components/uploadAsb/Asb')

const GlobalPositionsList = ()=> import('@/components/globalPositions/GlobalPositionsList')

const ContractList = ()=> import('@/components/contract/contractList/ContractList')
const ContractEdit = ()=> import('@/components/contract/contractEdit/ContractEdit')
const ContractSection = ()=> import('@/components/contract/contractEdit/section/ContractSection')
const ContractAddressSection = ()=> import('@/components/contract/contractEdit/section/AddressSection')
const ListSection = ()=> import('@/components/contract/contractEdit/section/ListSection')
const PositionSection = ()=> import('@/components/contract/contractEdit/section/PositionSection')

const OrderList = ()=> import('@/components/order/orderList/OrderList')
const OrderImport = ()=> import('@/components/order/orderList/OrderImport')

const Manual = ()=> import('@/components/manual/Manual')

const HausanschlussEdit = ()=> import('@/components/order/hausanschlussEdit/Main')
const HausanschlussOrderSection = ()=> import('@/components/order/hausanschlussEdit/section/Order')
const HausanschlussHierarchySection = ()=> import('@/components/order/hausanschlussEdit/section/Hierarchy')
const HausanschlussMBFDSection = ()=> import('@/components/order/hausanschlussEdit/section/mbfd/MBFD')
const HausanschlussDocumentationSection = ()=> import('@/components/order/hausanschlussEdit/section/Documentation')
const HausanschlussUploadSection = ()=> import('@/components/order/hausanschlussEdit/section/Upload')
const HausanschlussHistorySection = ()=> import('@/components/order/hausanschlussEdit/section/History')
const HausanschlussAssignmentSection = ()=> import('@/components/order/hausanschlussEdit/section/Assignment')
const HausanschlussMeasurementListSection = ()=> import('@/components/order/hausanschlussEdit/section/measurement/MeasurementList')
const HausanschlussMeasurementSection = ()=> import('@/components/order/hausanschlussEdit/section/measurement/Measurement')

const VerteilnetzEdit = ()=> import('@/components/order/verteilnetzEdit/Main')
const VerteilnetzOrderSection = ()=> import('@/components/order/verteilnetzEdit/section/Order')
const VerteilnetzUploadSection = ()=> import('@/components/order/verteilnetzEdit/section/Upload')
const VerteilnetzHistorySection = ()=> import('@/components/order/verteilnetzEdit/section/History')
const VerteilnetzAssignmentSection = ()=> import('@/components/order/verteilnetzEdit/section/Assignment')

Vue.use(Router)

const router = new Router({
	  routes: [
		    {
		    	path: '/',
				beforeEnter: (to, from, next) => {
					next({
						path: 'order/orderlist'
					})
				}
		    },
		    {
		    	path: '/login',
		    	component: Login,
		    	meta: {requiresNoAuth: true}
		    },
		    {
		        path: '/checkLogin',
		        component: CheckLogin,
		        meta: {requiresNoAuth: true}
		    },
		    {
		      path: '/admin/userList/',
		      component: UserList,
		      meta: {permissions: ['seeUser', 'editUser']}
		    },
		    {
		      path: '/admin/groupList',
		      component: GroupList,
		      meta: {permissions: ['seeGroups', 'editGroups']}
		    },

		    {
		      path: '/admin/groupEdit/:id',
		      component: GroupEdit,
		      meta: {permissions: ['seeGroups', 'editGroups']},
		      children: [
		    	  {
		              path: 'group',
		              component: GroupSection
		    	  },
		    	  {
		    		  path: 'permission',
		    		  component: GroupPermissionSection

		    	  },
		    	  {
   	 				 path: 'layout',
   	 			     component: GroupLayoutSection,
		   	 	 	 children: [
		   	 			 {
		   	 				 path: 'layoutList',
		   	 			     component: GroupLayoutListSubSection,
		   	 			 },
		   	 			 {
		   	 				 path: '/',
					 		 beforeEnter: (to, from, next) => {
					 			 next({
					 				 path: to.path+"/layoutList"
					 			 })
					 		 }
		   	 			 },
		   	 			 {
		   	 				 path: 'layoutEdit/:layoutId',
		   	 			     component: GroupLayoutEditSubSection,
		   	 			 },
		   	 	 	 ]
   	 			  },
		    	  {
		              path: '',
			 		  beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"group"
			 			 })
			 		  }
		    	  },
		      ]

		    },

			{
		  	  path: '/admin/clientEdit/:id',
		  	  component: ClientEdit,
		  	  meta: {permissions: ['seeClients', 'editClients']},
		  	  children: [
		  		 {
		  			 path:'client',
		  			 component: ClientSection
		  		 },
		    	 {
		    		 path: 'permission',
		    		 component: ClientPermissionSection

		    	 },
		    	 {
		    		 path: 'user',
		    		 component: ClientUserSection

		    	 },
		  		 {
		  			 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"client"
			 			 })
			 		 }
		  		 }
		  	  ]
		    },
		    {
		      path: '/admin/stats/',
		      component: Stats,
		      children: [
			     {
			    	 path:'user',
			    	 component: StatsUserSection
			 	 },
			 	 {
			 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"user"
			 			 })
			 		 }
			 	 }
			   ]
		     },

		    {
		      path: '/admin/userEdit/:id',
		      component: UserEdit,
		      meta: {permissions: ['seeUser', 'editUser', 'selfUser']},
		      children: [
		 	     {
		 	    	 path:'user',
		 	    	 component: UserSection,
		 	 	 },
		 	 	 {
		 	 		 path:'address',
		 	 		 component: UserAddressSection,
		 	 	 },
		 	 	{
   	 				 path: 'layout',
   	 			     component: UserLayoutSection,
		   	 	 	 children: [
		   	 			 {
		   	 				 path: 'layoutList',
		   	 			     component: UserLayoutListSubSection,
		   	 			 },
		   	 			 {
		   	 				 path: '/',
					 		 beforeEnter: (to, from, next) => {
					 			 next({
					 				 path: to.path+"/layoutList"
					 			 })
					 		 }
		   	 			 },
		   	 			 {
		   	 				 path: 'layoutEdit/:layoutId',
		   	 			     component: UserLayoutEditSubSection,
		   	 			 },
		   	 	 	 ]
   	 			 },
			 	 {
			 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"user"
			 			 })
			 		 }
			 	 }
		 	   ]
		    },
		    {
			  path: '/admin/clientList',
			  component: ClientList,
			  meta: {permissions: ['seeClients', 'editClients']}
			},
			{
			  path: '/messages/messageList',
			  component: MessageList,
			  //meta: {permissions: ['seeBuildingInstructions']}
			},
			{
			  path: '/messages/message/:id',
			  component: Message,
			  //meta: {permissions: ['seeBuildingInstructions']}
			},
			{
			  path: '/messages/newMessage',
			  component: MessageWrite,
			  //meta: {permissions: ['seeBuildingInstructions']}
			},
		    {
			  path: '/globalFiles/',
			  component: GlobalFiles,
			  meta: {permissions: ['seeGlobalFiles']}
			},
		    {
				  path: '/uploadAsb/',
				  component: UploadAsb ,
				  meta: {permissions: ['uploadAsb', 'editOrderASB', 'seeOrderASB']}
			},
		    {
		      path: '/contract/contractEdit/:id',
		      component: ContractEdit,
		      meta: {permissions: ['seeContracts', 'seeContracts']},
		      children: [
		  	     {
		  	    	 path:'contract',
		  	    	 component: ContractSection
		  	 	 },
		  	 	 {
		  	 		 path:'address',
		  	 		 component: ContractAddressSection
		  	 	 },
		  	 	 {
		  	 		 path:'list',
		  	 		 component: ListSection
		  	 	 },
		  	 	 {
		  	 		 path:'position',
		  	 		 component: PositionSection,
					 meta: {permissions: ['seeContractPositions', 'editContractPositions']},
		  	 	 },
		 	 	 {
		 	 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"contract"
			 			 })
			 		 }
		 	 	 }
		  	   ]
		    },
		    {
		      path: '/contract/contractList/',
		      component: ContractList,
		      meta: {permissions: ['seeContracts', 'seeContracts']},
		    },
			{
			  path: '/globalPositionsList/',
			  component: GlobalPositionsList,
			  meta: {permissions: ['seeGlobalPositions', 'editGlobalPosition']},
			},
		    {
		      path: '/order/orderList/:status?',
		      component: OrderList,
		      meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders'], type: 'ha'}
		    },
			{
			  path: '/network/networkList/',
			  component: OrderList,
			  meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders'], type: 'vn'}
			},
		    // {
			//   path: '/order/orderImport',
			//   component: OrderImport
			// },
		    {
		      path: '/order/orderEdit/:id',
		      component: HausanschlussEdit,
		      meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders']},
		      children: [
		   	     {
		   	    	 path:'order',
		   	    	 component: HausanschlussOrderSection
		   	 	 },
		   	 	 {
		   	 		 path:'hierarchy',
		   	 		 component: HausanschlussHierarchySection,
		   	 		 meta: {permissions: ['seeOrderHierachy', 'editOrderHierachy']},
		   	 	 },
		   	 	 {
		   	 		 path:'assignment',
		   	 		 component: HausanschlussAssignmentSection,
		   	 		 meta: {permissions: ['editClientAssignment', 'editUserAssignment']},

		   	 	 },
		   	 	 {
		   	 		 path:'history',
		   	 		 component: HausanschlussHistorySection,
		   	 		 meta: {permissions: ['seeOrderHistory']},
		   	 	 },
		   	 	 {
		   	 		 path:'mbfd',
		   	 		 component: HausanschlussMBFDSection,
		   	 		 meta: {permissions: ['editMBFD', 'seeMBFD']},
		   	 	 },
		   	 	 {
		   	 		 path:'documentation',
		   	 		 component: HausanschlussDocumentationSection,
		   	 		 //meta: {permissions: ['seeOrderDownloads']},
		   	 	 },
		   	 	 {
		   	 		 path:'upload',
		   	 		 component: HausanschlussUploadSection,
		   	 		 meta: {permissions: ['seeOrderDownloads']},
		   	 	 },
				 {
		   	 		 path:'measurement/:measurementId',
		   	 		 component: HausanschlussMeasurementSection,
		   	 		 meta: {permissions: ['seeMeasurements']},
		   	 	 },
		   	 	 {
		   	 		 path:'measurementList',
		   	 		 component: HausanschlussMeasurementListSection,
		   	 		 meta: {permissions: ['seeMeasurements']},
		   	 	 },
		  	 	 {
		  	 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"order"
			 			 })
			 		 }
		  	 	 }
		   	   ]
		    },
			{
				path: '/network/networkEdit/:id',
				component: VerteilnetzEdit,
				meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders']},
				children: [
					{
						path:'order',
						component: VerteilnetzOrderSection
					},
					{
						path:'assignment',
						component: VerteilnetzAssignmentSection,
						meta: {permissions: ['editClientAssignment', 'editUserAssignment']},

					},
					{
						path:'history',
						component: VerteilnetzHistorySection,
						meta: {permissions: ['seeOrderHistory']},
					},
					{
						path:'upload',
						component: VerteilnetzUploadSection,
						meta: {permissions: ['seeOrderDownloads']},
					},
					{
						path:'',
						beforeEnter: (to, from, next) => {
							next({
								path: to.path+"order"
							})
						}
					}
				]
			},
		    {
		      path: '/download',
		      component: Download,
		      meta: {permissions: ['seeGlobalDownload']}
		    },
		    {
		      path: '/map',
		      component: Map,
		      meta: {permissions: ['seeGlobalMap']}
		    },
		    {
			  path: '/manual/:section',
			  component: Manual
			},
		    {
		      path: "*",
		      component: Error,
		    }
		  ]
		});


router.beforeEach((to, from, next) => {
	if(!store.getters['user/isLoggedIn']){
		if(to.matched[0].meta.requiresNoAuth) {
			next();
		} else {
			next({
				path: '/checkLogin',
	        	query: {redirect: to.fullPath}
			})
		}
	} else {
		if(to.matched[0].meta.requiresNoAuth) {
			next({
				path: from.fullPath
			});
		} else {
			var permission = true;
			to.matched.forEach((entry) => {
				if(entry.meta.permissions !== undefined) {
					if(!Vue.$auth.hasPermission.apply(null, entry.meta.permissions)) {
						permission = false;
					}
				}
			});
			if(permission) {
				next();
			} else {
				next({
					path: '/error',
		        	query: {redirect: to.fullPath}
				})
			}
		}
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js